export default "__VITE_ASSET__Evu0RB3b__"